import React from 'react';
import { ECLIPSE_LIGHT_PRODUCT_FAMILY_ID, WIXEL_LIGHT_COUPON_PREFIX } from '@wix/package-picker-shared';
import { extractNumericRate } from '../../../utils/extractNumericRate';
import { useCurrentModule } from '../../ModuleProvider';
const COUPON_NAMES_MAP = {
  partner_discount: 'checkout.partner_copoun',
  domain_discount: 'checkout.domain_coupon',
  Wix2XMigration40: 'checkout_special_discount_40'
};

/**
 * Returns a getCouponLabel function that maps a coupon code to its display label.
 *
 * Mirrors getCouponLabel from premium-purchase-plan's CheckoutPage.controller.ts.
 *
 * Wixel Light branch: same availability check sunrise performs server-side —
 * the offering's Light product has a coupon whose id starts with
 * WIXEL_LIGHT_COUPON_PREFIX. Read from pricingDetails[i].couponPricing.couponInfo.id.
 *
 * discount.rate is a string like "50%" per @wix/ambassador-premium-purchase-platform-v1-offering types.
 */
export const useCouponLabel = () => {
  var _offering$products, _lightProduct$pricing;
  const module = useCurrentModule();
  const {
    t
  } = module.internals.useTranslations();
  const selectedProductId = module.SDK.PackagePickerStore.useSelectedProductId();
  const {
    data: offering
  } = module.SDK.eclipseOfferingApiClient.hooks.useFetchOffering({});
  const {
    data: discountData
  } = module.SDK.eclipseOfferingApiClient.hooks.useFetchOfferingDiscount({});
  const lightProduct = offering == null || (_offering$products = offering.products) == null ? void 0 : _offering$products.find(p => p.productFamilyId === ECLIPSE_LIGHT_PRODUCT_FAMILY_ID);
  const isWixelLightCouponAvailable = (lightProduct == null || (_lightProduct$pricing = lightProduct.pricingDetails) == null ? void 0 : _lightProduct$pricing.some(pd => {
    var _pd$couponPricing;
    return (_pd$couponPricing = pd.couponPricing) == null || (_pd$couponPricing = _pd$couponPricing.couponInfo) == null || (_pd$couponPricing = _pd$couponPricing.id) == null ? void 0 : _pd$couponPricing.startsWith(WIXEL_LIGHT_COUPON_PREFIX);
  })) ?? false;
  const isLightSelected = (lightProduct == null ? void 0 : lightProduct.productId) === selectedProductId;
  return React.useCallback(couponName => {
    var _discountData$discoun;
    // Wixel Light coupon branch
    if (isWixelLightCouponAvailable && isLightSelected) {
      return t('premium-purchase-plan.checkout_summary.wixel.free_plan_voucher.coupon_name');
    }

    // Named coupon branch
    if (COUPON_NAMES_MAP[couponName]) {
      return t(COUPON_NAMES_MAP[couponName]);
    }

    // Sale branch: rate is a string like "50%" (may use Arabic/CJK percent symbols)
    if (discountData != null && discountData.hasSale && (_discountData$discoun = discountData.discount) != null && _discountData$discoun.rate) {
      const percent = parseInt(extractNumericRate(discountData.discount.rate), 10);
      if (!isNaN(percent)) {
        return t('sale.product.x_off', {
          percent
        });
      }
    }
    return '';
  }, [discountData, t, isWixelLightCouponAvailable, isLightSelected]);
};
//# sourceMappingURL=useCouponLabel.js.map